import Contato from "./Contato";
import Hero from "./Hero";
import Portfolio from "./Portfolio";
import Serviços from "./Serviços";

export default function App(){
    return(
        <>
        <Hero />
        <Serviços />
        <Portfolio />
        <Contato />
        </>
    )
}